import React, {Component} from "react";
import ReactEcharts from "echarts-for-react";
import {reqAnalysis} from "../../api";
class LineEcharts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dates: [],
            items: [],
            rotateX: 0,//x轴文字倾斜角度
        }
    }

    getAnalysis = async (optType) => {
        let result = await reqAnalysis(optType);
        if (result.code === 200) {
            this.setState(result.data);
            const dates = [];
            const items = [];
            let item = {
                data: [],
                type: 'bar',
                name: '',
                barMaxWidth: '30',
                itemStyle: {
                    normal: {
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: '#0B8DEB',
                            }
                        }
                    }
                },
            };
            result.data.data.map(o => {
                dates.push(o.dt + '/' + o.orderId + '/' + o.orderNo);
                item.data.push(o.days);
            });
            items.push(item);
            this.setState({
                dates: dates,
                items: items,
                averageDays: result.data.averageDays.toFixed(1),
                rotateX: result.data.data.length > 24 ? 45 : 0,
            });
        }
    };
    clickEcharts = (e) => {
        this.props.history.push('/trackInfo', {orderId: e.name.split('/')[1]});
    };

    getOtion() {
        const option = {
            title: {
                text: '时效分析 平均时长' + (this.state.averageDays) + '天',
                left: '37%',
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '0',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: this.state.dates,
                axisLabel: {
                    interval: 0,
                    rotate: this.state.rotateX,
                    formatter: function (value, index) {
                        return value.substring(0, 5)
                    }
                }
            },
            yAxis: {
                axisLabel: {
                    formatter: function (value, index) {
                        return value + '天';
                    }
                }
            },
            color: ['#0B8DEB'],
            series: this.state.items
        };
        return option
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.optType != this.state.optType) {
            this.getAnalysis(nextProps.optType);
            this.setState({optType: nextProps.optType});
        }
    }

    render() {
        return (
            <ReactEcharts
                option={this.getOtion()}
                style={{height: '200px', width: '100%'}}
                className='react_for_echarts'
                onEvents={{'click': this.clickEcharts,}}
               /* showLoading={{
                    text: '暂无数据',
                    color: '#ffffff',
                    textColor: '#8a8e91',
                    maskColor: 'rgba(255, 255, 255, 0.8)',
                }}*//>
        )
    }
}

export default LineEcharts;
